import { device } from '../../common/functions/device'

const menuDesignEditor = {
  checkoutButtonColor: '#FFFFFF',
  iconCode: 'fas fa-shopping-cart',
}

const menuContentEditor = {
  loginBtnText: 'Entrar',
  signupBtnText: 'Registre-se',
  accountBtnText: 'Minha conta',
  signoutBtnText: 'Sair'
}

const additionalDataMock = {
  device: device()
}

export {
  menuDesignEditor,
  menuContentEditor,
  additionalDataMock,
}
